import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { BaseResponse } from 'types/utils'

import type { SettlementListItem, SettlementStatus } from '../types'

export const settlementsQueryKey = ['settlements']

interface UseSettlementsParams {
  flat?: string
  status?: SettlementStatus
  year?: number
  enabled?: boolean
}

export function useSettlements({
  flat,
  status,
  year,
  enabled = true
}: UseSettlementsParams = {}) {
  async function getSettlements() {
    const response = await apiClient.get<BaseResponse<SettlementListItem>>(
      SNA_PREFIX + 'settlements',
      { params: { flat, status, year, limit: 100 } }
    )

    return response.data
  }

  return useQuery({
    queryFn: getSettlements,
    enabled,
    queryKey: [...settlementsQueryKey, flat, status, year]
  })
}
